module.exports = __webpack_public_path__ + "img/w3_button_close_light.aff057e9.png";